<template>
  <div class="languageSelection">
    <!--<ListSelect id="langSelect" @select="onSelect" :list="locales" option-value="code" option-text="name" :selected-item="selectedLocale"></ListSelect>-->
    <flag :squared="false" :iso="selectedLocale.flag"/>
    <v-select label="name" :options="locales" :clearable="false" :searchable="false" :value="selectedLocale" @input="onSelect">
      <template slot="option" slot-scope="option">
        <flag :squared="false" :iso="option.flag"/> <span>{{option.name.toUpperCase()}}</span>
      </template>
    </v-select>
  </div>
</template>

<script>
import Config from './../config';
import LocaleService from './../services/locale-service';
import 'vue-select/src/scss/vue-select.scss'
import vSelect from 'vue-select'

export default {
  name: 'LocaleSelector',
  components: {
    vSelect
  },
  data () {
    return {
      locales: Config.locales,
      selectedLocale: {}
    }
  },
  methods: {
    changeLocale: function() {
      LocaleService.setLocale(this.selectedLocale.code);
      this.flag = this.selectedLocale.flag;
    },
    onSelect: function(item) {
      this.selectedLocale = item;
      this.changeLocale();
      this.$emit('changed', this.selectedLocale.code);
    },
    getLocale: function(code) {
      let p = this.locales.filter(l => l.code === code);
      return p[0];
    }
  },
  mounted() {
    this.$nextTick(() => {
      let localeCode = LocaleService.getLocale();
      this.selectedLocale = this.getLocale(localeCode);
    });
  }
}
</script>
<style lang="scss">
  @import '../styles/variables';
  .languageSelection {
    margin: 0 1em;
  }
  .vs__dropdown-toggle, .vs__dropdown-menu, .vs__dropdown-option, .vs__selected {
    border: none !important;
    text-transform: uppercase !important;
    color: #422bf2 !important;

    @media (max-width: $tabletSmall) {
      font-size: 1.125em;
    }

    @media(min-width: $tabletSmall) {
      font-size: 0.8333em;
    }

    @media(min-width: 1200px) {
      font-size: 1.125em;
    }
  }
  .vs__search {
    color: transparent;
  }
  .v-select {
    display: inline-block;
    width: 150px;
  }
  .flag-icon {
    @media(min-width: $tabletSmall) {
      top: 0px;
    }

    @media(min-width: 1200px) {
      top: -2px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/LocaleSelector.vue